import { AxiosPromise } from 'axios';
import { ApiResponseEntity, NotificationDTO } from 'types';

import axios from 'utils/axios';

const API_PATH = '/secured/notification';

export default class NotificationApi {
    static getNotifications(): AxiosPromise<ApiResponseEntity<NotificationDTO[]>> {
        return axios.get(`${API_PATH}/all`);
    }

    static seenNotification(id: number): AxiosPromise<ApiResponseEntity<void>> {
        return axios.get(`${API_PATH}/detail/${id}`);
    }

    static deleteAllReadNotification(): AxiosPromise<ApiResponseEntity<void>> {
        return axios.delete(`${API_PATH}/delete-all-read`);
    }

    static deleteAllNotification(): AxiosPromise<ApiResponseEntity<void>> {
        return axios.delete(`${API_PATH}/delete-all`);
    }
}
